import { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../../../reducers";

import DeleteIcon from '../../../../media/felsv/dark_recyclebin_icon.svg'
import EditIcon from '../../../../media/felsv/PenEdit.svg'
import DolarIcon from '../../../../media/felsv/Dollar.svg'
import PorcentageIcon from '../../../../media/felsv/Porcentaje.svg'
import HelpIcon from '../../../../media/felsv/help-circle-svgrepo-com.svg';

import BasicCardDocumentos from "../BasicCardDocumentos";
import InputForm from "../InputFormV2";
import SwitchTipoProductoDTE from "../BasicSwitchTipoProducto";
import { Pagination } from "../../../../components/Pagination";

import useNotaDebito, {enDolares, montosDeProducto} from "../../../../actions/nota-debito.actions";
import { actionGeneral, actionsLogin } from "../../../../actions/action-creators";
import { BannerElegirSucursal } from "../../../../components/Banner/BannerElegirSucursal";
import DocumentosReceptor from "../../../../components/DocumentoReceptor/DocumentosReceptor";
import ObservacionesDocumentoBase from "../../../../components/ObservacionesDocumento/ObservacionesDocumento";
import { NOTA_DEBITO_TYPES } from "../../../../constants/nota-debito.types";
import { getMinDateRetroactiva } from "../../../../utils/stringDate"
import InputChips from "../InputChips";
import { Tooltip } from "../../../../components/Tooltip/Tooltip";
import { esCatalogoProductoByTipo, processDetalleImpuestosHTML } from "../../../../actions/utils-documentos.actions";
import InputSwitchDescripcion, { CheckBoxFlag } from "../InputSwitchDescripcion";
import CamposReceptorNotaV2 from "../CamposV2/CamposReceptorNotaV2";
import {telefonoParaInput} from '../../../../utils/strings.utils'

export default function FormulariosND (){
    const {fecha_actual} = useSelector((state: State) => state.general)
    const config = useSelector((state: State) => state.userLogin.config)
    const {formCliente, errorsCliente, formProducto, errorsProducto, calculosProducto, productos, formObservaciones} = useSelector((state: State) => state.notaDebito)
    const {DetallesDTE: {receptor, identificacion}, TipoContribuyenteReceptor} = useSelector((state: State) => state.historial.activeFactura);
    const {departamentos, municipios, actividadesEconomicas, productos: productosCatalogo, unidadesMedida} = useSelector((state: State) => state.catalogos)
    const receptorGranContribuyente = TipoContribuyenteReceptor === 'true'

    const [customDescripcion, setCustomDescripcion] = useState(false);
    const [checkTextoEnrequecido, setCheckTextoEnrequecido] = useState(false);

    const dispatch = useDispatch();
    const {suscripcionGetFacturasDisponibles} = bindActionCreators(actionsLogin, dispatch)
    const {getFechaHora, validateHorarioSucursal, validateUsoModulo} = bindActionCreators(actionGeneral, dispatch)
    
    const {
        onChangeFormCliente,
        distritoDelReceptor,
        onChangeFormProducto,
        onChangeSelectCatalogoProducto,
        cargarDatosIniciales,
        cargarProductosIniciales,
        buscarCliente,

        button_onClickAgregarProducto,
        button_onClickLimpiarFormProducto,

        validateFormCliente,
        validateFormProducto,

        actionButton_editar,
        actionButton_eliminarProducto,

        cargarSucursales,
        calculosProductos,
    } = useNotaDebito()

    const totales = calculosProductos()

    const handleChangeFormCliente = (e: any) => {
        onChangeFormCliente(e.target.name, e.target.value)
    }
    const handleChangeFormProducto = (e: any) => {
        onChangeFormProducto(e.target.name, e.target.value)
        if (e.target.name === "descripcion" && e.target.value === "") {setCustomDescripcion(false)}
    }
    const handleBlurFormCliente = async(e: any) => {
        validateFormCliente(e.target.name, e.target.value)
        if(e.target.name === 'noDocumento') await buscarCliente()
    }
    const handleBlurFormProducto = (e: any) => {
        validateFormProducto(e.target.name, e.target.value)
    }
    const handleSelectCatalogoProducto = (e: any) => {
        if (e.label != -1) onChangeSelectCatalogoProducto(e.value);
        else {
            setCustomDescripcion(true);
            setCheckTextoEnrequecido(false);
            onChangeFormProducto('descripcion', e.value, {clave: '', tributos: []});
        }
    }

    useEffect(() => {
        validateUsoModulo('/history-invoice?reload=0');
        validateHorarioSucursal('', '/history-invoice?reload=0')
        suscripcionGetFacturasDisponibles()
        cargarSucursales()
        cargarDatosIniciales()
        cargarProductosIniciales()
        getFechaHora();
    }, [])

    const [tableProductos, setTableProductos] = useState(productos)
    useEffect(() => {
        setTableProductos(productos);
    }, [productos])

    return(
        <>
            <BannerElegirSucursal />
            <div style={{width: '100%'}}>
                <div className='card w-form' style={{textAlign: 'center'}}>
                    <label className="card-title" style={{fontSize: '20px'}}>DOCUMENTO DE REFERENCIA</label>
                    <p style={{margin: 0}}>{identificacion?.numeroControl ?? "---"}</p>
                </div>   
            </div>
            <div className="otros-documentos-container">
                <div className='dos-columnas-resp'>
                <div className='form-content'>
                <BasicCardDocumentos title="Datos del cliente">
                        <InputForm disabled={true} required name = 'granContribuyente' label = 'Gran contribuyente' type = 'checkbox' value = {receptorGranContribuyente} onChange = {(e: any) => onChangeFormCliente('granContribuyente', !receptorGranContribuyente)}/>
                    <div className='w-layout-hflex h-inputs'>
                        <InputForm name = 'fecha' placeholder = 'Fecha de emisión' label = 'Fecha' type = 'date'
                            value = {config?.facturacion_retroactiva ? formCliente.fecha : fecha_actual?.FechaInput}
                            disabled = {!config?.facturacion_retroactiva}
                            min = {config?.facturacion_retroactiva && config?.dias_facturacion_retroactiva && fecha_actual?.FechaInput ? getMinDateRetroactiva(config.dias_facturacion_retroactiva, fecha_actual.FechaInput) : undefined}
                            max = {config?.facturacion_retroactiva ? fecha_actual?.FechaInput : undefined}
                            onChange = {config?.facturacion_retroactiva ? (e: any) => onChangeFormCliente('fecha', e.target.value) : undefined}
                        />
                        <InputForm disabled={true} onBlur = {handleBlurFormCliente} required name = 'noDocumento' placeholder = 'NIT' label = 'NIT' type = 'text' value = {receptor?.nit} onChange = {handleChangeFormCliente}/>
                    </div>
                    <div className='w-layout-hflex h-inputs'>
                        <InputForm disabled={true} maxLength = {50} onBlur = {handleBlurFormCliente} required name = 'nombre' placeholder = 'Nombre' label = 'Nombre' type = 'text' value = {receptor?.nombre} onChange = {handleChangeFormCliente}/>
                    </div>
                    <div className='w-layout-hflex h-inputs'>
                        <InputForm disabled={true} required options = {departamentos?.map((dep) => ({...dep, codigo_nombre: `${dep.codigo} - ${dep.valor}`}))} keyNameText = 'codigo_nombre' keyNameValue = 'codigo' name = 'departamento' placeholder = 'Departamento' label = 'Departamento' type = 'select' value = {receptor?.direccion?.departamento} onChange = {(e: any) => onChangeFormCliente('departamento', e.value)}/>
                        <InputForm disabled={true} required options = {municipios?.map((mun) => ({...mun, codigo_nombre: `${mun?.codigo} - ${mun?.valor}`}))} keyNameText = 'codigo_nombre' keyNameValue = 'codigo' name = 'municipio' placeholder = 'Municipio' label = 'Municipio' type = 'select' value = {receptor?.direccion?.municipio} onChange = {(e: any) => onChangeFormCliente('municipio', e.value)}/>
                    </div>
                    <div className='w-layout-hflex h-inputs'>
                        <InputForm disabled={true} maxLength = {60} onBlur = {handleBlurFormCliente} required name = 'direccion' placeholder = 'Dirección' label = 'Dirección' type = 'text' value = {receptor?.direccion?.complemento} onChange = {handleChangeFormCliente}/>
                    </div>
                    <div className='w-layout-hflex h-inputs'>
                        <InputChips disabled={true} maxChips={5} chips={formCliente.chipsEmail} required name = 'email' placeholder = 'Correo electrónico' label = 'Correo electrónico' type = 'text' value = {receptor?.correo} />
                        {/* <InputForm maxLength = {50} onBlur = {handleBlurFormCliente} required name = 'email' placeholder = 'Correo electrónico' label = 'Correo electrónico' type = 'text' value = {formCliente.email} error = {errorsCliente.email} onChange = {handleChangeFormCliente}/> */}
                    </div>
                    <div className='w-layout-hflex h-inputs'>
                        <InputForm disabled={true} required options = {actividadesEconomicas.map((act) => ({...act, codigo_valor: `${act.codigo}-${act.valor}`}))} keyNameText = 'codigo_valor' keyNameValue = 'codigo' name = 'actividad' placeholder = 'Actividad económica' label = 'Actividad económica' type = 'select' value = {receptor?.codActividad} onChange = {(e: any) => onChangeFormCliente('actividad', e.value)}/>
                        <InputForm disabled={true} onBlur = {handleBlurFormCliente} required name = 'telefono' placeholder = 'Teléfono celular' label = 'Teléfono celular' type = 'phone' value = {telefonoParaInput(receptor?.telefono)} onChange = {(phone: any) => onChangeFormCliente('telefono', phone)}/>
                    </div>
                    <div className='w-layout-hflex h-inputs'>
                        <div className='label-input'>
                        <InputForm disabled={true} maxLength = {14} onBlur = {handleBlurFormCliente} required = {formCliente.tipoDocumento === '36'} name = 'nrc' placeholder = 'NRC' label = 'NRC' type = 'text' value = {receptor?.nrc} onChange = {handleChangeFormCliente}/>
                        </div><div className='label-input'></div>
                    </div>
                    {/* <div className='form-separator'></div>
                    <div><h3 className='card-title l'>Condición de la operación</h3></div>
                    <div className='form-separator'></div>
                    <div className='label-input'>
                        <InputForm options = {condicionOperacion} required keyNameText = 'valor' keyNameValue = 'codigo' name = 'condicion' placement='top' placeholder = 'Condición de la operación' label = 'Forma de pago' type = 'select' value = {formCliente.condicion} onChange = {(e: any) => onChangeFormCliente('condicion', e.value)} error = {errorsCliente.condicion} />
                    </div>  */}
                </BasicCardDocumentos>
                <CamposReceptorNotaV2
                    numDocumento = {receptor?.nit}
                    departamento = {receptor?.direccion?.departamento}
                    municipio = {receptor?.direccion?.municipio}
                    distrito = {distritoDelReceptor()}
                    errorDistrito = {errorsCliente.distrito}
                    onChangeDistrito = {(valor: string) => onChangeFormCliente('distrito', valor)}
                    codigoRetencionMH = {formCliente.codigoRetencionMH}
                    errorCodigoRetencionMH = {errorsCliente.codigoRetencionMH}
                    onChangeCodigoRetencionMH = {(valor: string) => onChangeFormCliente('codigoRetencionMH', valor)}
                />
                </div> 
                <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ecd-0b1e6fa6' className='w-layout-cell'>
                <BasicCardDocumentos title="Sucursal y serie">
                  <div className='w-layout-hflex h-inputs'>
                      <InputForm disabled={true} required options = {formCliente?.datosSucursal} keyNameText = 'nombre' keyNameValue = 'idsucursal' name = 'sucursal' placeholder = 'Sucursal' label = 'Sucursal' type = 'select' value = {formCliente.sucursal} error = {errorsCliente.sucursal} onChange = {(e: any) => onChangeFormCliente('sucursal', e.value)}/>
                      <InputForm disabled={!formCliente.loadedSucursal} required options = {formCliente?.datosSucursal?.find((suc: any) => suc?.idsucursal === formCliente?.sucursal)?.Documento?.map((doc: any) => ({...doc, serie_numero: `${doc.serie}-${doc.numeroactual}`}))} keyNameText = 'serie_numero' keyNameValue = 'idsucursaldocumento' name = 'serie' placeholder = 'Serie' label = 'Serie' type = 'select' value = {formCliente.serie} error = {errorsCliente.serie} onChange = {(e: any) => onChangeFormCliente('serie', e.value)}/>
                  </div>
                  <div>
                      <h3 className="card-title">Producto o Servicio</h3>
                  </div>
                  <hr className="separador"/>
                  <SwitchTipoProductoDTE producto = {!formProducto.servicio} setProducto = {() => onChangeFormProducto('servicio', false)} setServicio = {() => onChangeFormProducto('servicio', true)}/>
                  <div className="cf-row-inputs">
                  <InputForm required name = 'descripcion' label = 'Exento' type = 'checkbox' value = {formProducto.exento} onChange = {(e: any) => onChangeFormProducto('exento', !formProducto.exento)}/>
                  <InputForm required name = 'descripcion' label = 'Incluye IVA' type = 'checkbox' value = {formProducto.conIva} onChange = {(e: any) => onChangeFormProducto('conIva', !formProducto.conIva)}/>
                  </div>
                    {!formProducto.exento &&
                        <p style={{color: '#019FC5'}}>Nota: Este {formProducto.servicio ? 'servicio' : 'producto'} lleva un 13% extra por concepto de IVA. ( {formProducto.servicio ? 'Servicio' : 'Producto'} gravado)</p>
                    }
                    {
                        (!customDescripcion && productosCatalogo.length > 0)
                        ? 
                            <InputForm 
                                enableCreate={true} required 
                                label = 'Descripción' type = 'select' 
                                options = {productosCatalogo.filter((prod) => esCatalogoProductoByTipo(formProducto.servicio, prod))} 
                                keyNameText = 'descripcion' keyNameValue = 'clave' 
                                onChange = {handleSelectCatalogoProducto}
                                value = {formProducto.clave} error = {errorsProducto.descripcion}
                                componentSideLabel = {
                                    <CheckBoxFlag
                                      label="Activar texto con formato" 
                                      value={customDescripcion} 
                                      onChange={() => {
                                        setCustomDescripcion(true);
                                        setCheckTextoEnrequecido(true);
                                      }}
                                    />
                                }
                            />
                        : (
                            <div className="w-layout-hflex h-inputs">
                                <InputSwitchDescripcion defaultEnrequecido={checkTextoEnrequecido} className='m text-field w-input' maxLength = {1000} onBlur = {handleBlurFormProducto} required name = 'descripcion' placeholder = 'Descripción' label = 'Descripción' type = 'text' value = {formProducto.descripcion} error = {errorsProducto.descripcion} onChange = {handleChangeFormProducto}/>    
                            </div>
                        )
                    }
                <div style={{flexDirection: "row"}} >
                <div className={`ef-form-producto-div4`}>
                <div className='label-input'>
                  <InputForm maxLength = {15} onBlur = {handleBlurFormProducto} required name = 'cantidad' placeholder = '0' label = 'Cantidad' type = 'text' value = {formProducto.cantidad} error = {errorsProducto.cantidad} onChange = {handleChangeFormProducto}/>
                </div>
                <div className='label-input'>
                  <InputForm type = 'select' options = {unidadesMedida} keyNameText = 'valor' keyNameValue = 'codigo' onChange = {(e: any) => onChangeFormProducto('unidadMedida', e.value)} label = 'Unidad de medida' value = {formProducto.unidadMedida}/>
                </div>
                <div className='label-input'>
                  <InputForm maxLength = {15} onBlur = {handleBlurFormProducto} required name = 'precio' placeholder = '$0.00' label = 'Precio' type = 'text' value = {formProducto.precio} error = {errorsProducto.precio} onChange = {handleChangeFormProducto}/>
                </div>
                <div className='label-input'>
                  <InputForm options = {[{nombre: 'Porcentaje'}, {nombre: 'Monto'}]} required keyNameText = 'nombre' keyNameValue = 'nombre' name = 'tipoDescuento' placeholder = 'Tipo de descuento' label = 'Tipo de desc.' type = 'select' value = {formProducto.tipoDescuento} error = {null} onChange = {(e: any) => onChangeFormProducto('tipoDescuento', e.value)}/>
                </div>
                <div className='label-input'>
                  <InputForm 
                          maxLength = {formProducto.tipoDescuento === 'Porcentaje' ? 6 : 15}
                          leftIcon = {formProducto.tipoDescuento === 'Porcentaje' ? PorcentageIcon : DolarIcon}
                          type = 'text'
                          value = {formProducto.descuento}
                          name = 'descuento'
                          onChange = {(e: any) => onChangeFormProducto(e.target.name, e.target.value)}
                          placeholder = '0.00'
                          label = 'Descuento'
                          error = {errorsProducto.descuento}
                      />
                  </div>
                </div>
                </div>
                  <div className="cf-calculos-producto">
                      <table>
                          <tbody>
                              <tr className="cf-subtotal">
                                  <td>Valor bruto</td>
                                  <td>{calculosProducto?.neto}</td>
                              </tr>
                              <tr className="cf-descuento">
                                  <td>Descuento</td>
                                  <td>{calculosProducto?.descuento}</td>
                              </tr>
                              <tr className="cf-subtotal">
                                  <td>Subtotal</td>
                                  <td>{calculosProducto?.subtotal}</td>
                              </tr>
                              <tr className="cf-subtotal">
                                  <td>Impuesto al Valor Agregado 13%
                                  </td>
                                  <td>{calculosProducto?.iva}</td>
                              </tr>
                               <tr className="cf-subtotal opacity-full-gray">
                                    <td>
                                        <Tooltip content='Cálculo de impuestos aplica en el resumen'>
                                            <button className='table-action no-background'>
                                                <img src={HelpIcon} className='help-icon-button' />
                                            </button>
                                        </Tooltip>
                                        Otros impuestos
                                    </td>
                                    <td>{calculosProducto?.otrosImpuestos}</td>
                                </tr>
                              <tr className="cf-total">
                                  <td>Total</td>
                                  <td>{calculosProducto?.total}</td>
                              </tr>
                          </tbody>
                      </table>
                        <div className="w-layout-hflex button-actions">
                            <button className="button transparent" onClick={() => {button_onClickLimpiarFormProducto(); setCustomDescripcion(false)}}>Limpiar</button>
                            <button className="button" onClick={() => {button_onClickAgregarProducto(); setCustomDescripcion(false)}}>Agregar</button>
                        </div>
                  </div>
                </BasicCardDocumentos>
                </div>
                </div>
            </div>
            <div className="w-100">
                <div className="w-layout-layout bill-section wf-layout-layout">
                <BasicCardDocumentos title="Detalle de productos o servicios"  style={{maxWidth: "100%", boxShadow: "none"}}>
                    <div className="tab-plane">
                        <div className="table-facturacion-resp">
                        <table className="table-main-responsive responsive-table-main td-left table-pointer">
                            <thead>
                                <tr>
                                    <td>Cantidad</td>
                                    <td>Unidad de medida</td>
                                    <td>Tipo</td>
                                    <td>Descripción</td>
                                    <td>Precio unitario</td>
                                    <td>Otros impuestos</td>
                                    <td>Descuento</td>
                                    <td>Ventas gravadas</td>
                                    <td>Ventas exentas</td>
                                    <td>Acciones</td>
                                </tr>
                            </thead>
                            <tbody>
                                {tableProductos.map((producto, index) => {
                                    const {precioUni, descuento, venta} = montosDeProducto(producto)
                                    const detalleTributos = processDetalleImpuestosHTML(productosCatalogo, '06', producto, venta);

                                    return(
                                    <tr key={index}>
                                        <td data-label="Cantidad">{producto.cantidad}</td>
                                        <td data-label="Unidad de medida">{unidadesMedida.find((unidad) => unidad.codigo === producto.unidadMedida)?.valor}</td>
                                        <td data-label="Tipo">{`${producto.servicio ? 'Servicio' : 'Producto'} ${producto.exento ? ' exento' : ''}`}</td>
                                        <td data-label="Descripción" style={{wordBreak:"break-all"}}>{<div dangerouslySetInnerHTML={{ __html: producto.descripcion }} />}</td>
                                        <td data-label="Precio unitario">{enDolares(precioUni)}</td>
                                        <td data-label="Otros impuestos"><div dangerouslySetInnerHTML={{ __html: detalleTributos }} /></td>
                                        <td data-label="Descuento">{enDolares(descuento)}</td>
                                        <td data-label="Ventas gravadas">{enDolares(producto.exento ? 0 : venta)}</td>
                                        <td data-label="Ventas exentas">{enDolares(producto.exento ? venta : 0)}</td>
                                        {
                                        (!producto.original) ? 
                                            (
                                                <td data-label="Acciones">
                                                    <button onClick={() => actionButton_editar(producto)}><img src={EditIcon}/></button>
                                                    <button onClick={() => actionButton_eliminarProducto(producto.id)}><img src={DeleteIcon}/></button>
                                                </td>
                                            )
                                            :
                                            (
                                                <td data-label="Acciones">
                                                    <p style={{opacity: 0.5, fontSize: '10px'}}>Producto no modificable</p>
                                                </td>
                                            )
                                        } 
                                    </tr>
                                )})}
                            </tbody>
                        </table>
                        </div>
                        <Pagination data = {productos} state = {(items: Array<any>) => setTableProductos(items)} items = {10}/>
                        <div className="cf-calculos-producto">
                            <table>
                                <tbody>
                                    <tr className="cf-subtotal">
                                        <td>Suma de operaciones</td>
                                        <td>{enDolares(totales.sumaOperaciones)}</td>
                                    </tr>
                                    <tr className="cf-subtotal">
                                        <td>Impuesto al Valor Agregado 13%</td>
                                        <td>{enDolares(totales.iva)}</td>
                                    </tr>
                                    <tr className="cf-subtotal">
                                        <td>Otros impuestos
                                        </td>
                                        <td>{enDolares(totales.otrosImpuestos)}</td>
                                    </tr>
                                    <tr className="cf-subtotal">
                                        <td>Subtotal</td>
                                        <td>{enDolares(totales.subtotal)}</td>
                                    </tr>
                                    <tr className="cf-subtotal">
                                        <td>IVA percibido 1%</td>
                                        <td>{enDolares(totales.ivaPercibido)}</td>
                                    </tr>
                                    <tr className="cf-subtotal">
                                        <td>IVA retenido 1%</td>
                                        <td>{enDolares(totales.ivaRetenido)}</td>
                                    </tr>
                                    <tr className="cf-descuento">
                                        <td>Retencion renta 10%</td>
                                        <td>{enDolares(totales.retencionRenta)}</td>
                                    </tr>
                                    <tr className="cf-total">
                                        <td>Total</td>
                                        <td>{enDolares(totales.total)}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </BasicCardDocumentos>
                </div>
            </div>
            <div className="otros-documentos-container">
                <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec5-0b1e6fa6' className='w-layout-layout bill-section wf-layout-layout'>
                    <ObservacionesDocumentoBase formObservaciones={formObservaciones} onChange={(field, value) => dispatch({ type: NOTA_DEBITO_TYPES.ND_FORMOBSERVACIONES_HANDLE_CHANGE, payload: { [field]: value } })} />
                    <DocumentosReceptor />
                </div>
            </div>
        </>
    )
}